import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NeproseService } from '../services/neprose.service';
import { environment } from 'src/environments/environment';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  pages = [
    {value: 1, viewValue: 'Home Page'},
    {value: 2, viewValue: 'About Page'},
    {value: 3, viewValue: 'Contact Page'},
    {value: 4, viewValue: 'Blog Page'}
  ]

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/banner.jpg'})`+` no-repeat fixed center`)

  seoData: SeoSocialShareData = {
    title:  'Neprose - Contact',
    description: 'Nepal Property Services (NEPROSE) Birtamod 1, Jhapa, Nepal (behind National Tea and Coffee Development Board)',
    image: environment.url+'/assets/logo.png'
  };

  contactForm: FormGroup

  constructor( private _sanitizer: DomSanitizer, private neproseService: NeproseService, private seo: SeoSocialShareService, private notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.contactForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      message: new FormControl('', [Validators.required])
    })
    this.seo.setData(this.seoData)
    this.neproseService.getBannerImage(3).subscribe(data => {
      if(data.status){
        let banner = data.homeBanner
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+banner.imagePath})`+` no-repeat fixed center`)
      }
    })
  }

  submitContact(){
    let contactForm = this.contactForm.value
    this.neproseService.contact(contactForm).subscribe( data => {
      if(data.status){
        this.openNotification('Your message has been submitted! :)')
        this.contactForm.reset()
        Object.keys(this.contactForm.controls).forEach(key => {
          this.contactForm.get(key).setErrors(null) ;
        });
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
    
  }


  openNotification(message){
    this.notification.open(message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
